import { languages } from '../constants';
var isLanguage = function (language) {
    return languages.includes(language);
};
export default isLanguage;
//# sourceMappingURL=isLanguage.js.map